import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import SearchInput from 'search/inputs/SearchInput';

interface SearchEditorProps {
  config: string | null;
  onChangeConfig: (config: string | null) => void;
  modelTypes: Array<ModelTypeConstants>;
  schemaIds?: Array<string> | null;
  schemaInterfaceIds?: Array<string> | null;
  disabled?: boolean;
}

export default function SearchEditor({
  config,
  onChangeConfig,
  disabled,
  modelTypes,
  schemaIds,
  schemaInterfaceIds,
}: SearchEditorProps): JSX.Element {
  return (
    <SearchInput
      autoFocus={false}
      disabled={disabled}
      disableTyping={config != null}
      isMulti={false}
      onRemove={() => {
        onChangeConfig(null);
      }}
      onSelect={(itemId) => {
        onChangeConfig(itemId);
      }}
      placeholder=""
      schemaIds={schemaIds ?? undefined}
      schemaInterfaceIds={schemaInterfaceIds ?? undefined}
      selected={config == null ? [] : [config]}
      types={modelTypes}
    />
  );
}
